var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReplyBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    rx: 8,
    fill: "#841474"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2073 18.9417C25.6103 17.1007 23.2603 16.1207 20.2163 16.0247L20.2143 13.5427C20.2133 12.9887 19.9003 12.5007 19.3973 12.2677C18.8923 12.0337 18.3173 12.1127 17.8953 12.4717L10.9993 18.3157C10.6873 18.5787 10.5053 18.9627 10.4983 19.3687C10.4913 19.7727 10.6603 20.1587 10.9603 20.4287L17.8683 26.6737C18.2863 27.0507 18.8633 27.1437 19.3783 26.9167C19.8953 26.6877 20.2163 26.1927 20.2163 25.6267V22.4727C24.3203 22.5927 26.9493 24.2217 28.4663 27.5707C28.5473 27.7517 28.7273 27.8647 28.9213 27.8647C28.9443 27.8647 28.9683 27.8627 28.9913 27.8597C29.2123 27.8277 29.3853 27.6547 29.4163 27.4357C29.4453 27.2267 30.1113 22.2897 27.2073 18.9417Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyBox);
export default __webpack_public_path__ + "static/media/reply-box.4004cd48c361195e7ca8ca8e23d1bb2c.svg";
export { ForwardRef as ReactComponent };